<div class="info-container">
  <div class="info-icon">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_59557_8906)">
        <path
          d="M28.85 16.1898C28.85 23.2867 23.0969 29.0398 16 29.0398C8.90317 29.0398 3.15002 23.2867 3.15002 16.1898C3.15002 9.09298 8.90317 3.33984 16 3.33984C23.0969 3.33984 28.85 9.09298 28.85 16.1898Z"
          fill="#254C8C"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.1029 11.6189C15.7036 11.6189 15.4241 11.539 15.2644 11.3793C15.1046 11.2082 15.0248 10.9971 15.0248 10.7461V10.4723C15.0248 10.2214 15.1046 10.016 15.2644 9.85629C15.4241 9.68517 15.7036 9.59961 16.1029 9.59961C16.5021 9.59961 16.7816 9.68517 16.9414 9.85629C17.1011 10.016 17.1809 10.2214 17.1809 10.4723V10.7461C17.1809 10.9971 17.1011 11.2082 16.9414 11.3793C16.7816 11.539 16.5021 11.6189 16.1029 11.6189ZM12.2355 21.236H15.4184V14.7333H12.2355V13.5697H16.7873V21.236H19.7649V22.3996H12.2355V21.236Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_59557_8906">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="text-content">
    @if (headerText) {
      <div class="header-text">{{ headerText | translate }}</div>
    }
    <div class="sub-text" [class.no-header]="!headerText">{{ subText | translate }}</div>
  </div>
</div>
